import _ from "lodash";
import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import {
  genericIndexesStyles,
  tableStyles,
  variables,
} from "../../../../variables";
import Navbar from "./Navbar";
import ControlStrip from "../../../../components/ControlStrip";
import Loader from "../../../../components/Loader";
import { handleApplyFilters, medWeekdayDatetimer } from "../../../../helpers";
import DetailTranferModal from "../TranfersModals/DetailTranferModal";
import {
  fetchTransferReservations,
  getTransferReservationStats,
} from "../../../../api/CRS/Transfers";
import ReservationStats from "../../CommonCRSModals/ReservationStats/ReservationStats";
import { commonTableHeaders } from "../../helpers";
import { useQueries } from "@tanstack/react-query";
import HamburgerMenu from "../../../../components/HamburgerMenu";
import { genericRequestErrorHandler } from "../../../../api";
import { useListPageSidebar } from "../../../../hooks";
import * as yup from "yup";
import { CustomButton } from "../../../../components/CustomButton";
import CRSCxlCell from "../../../../components/CRSCxlCell";

const initialFilters = {
  limit: 20,
  page: 1,
  ordering: "",
  discending: "",
  guests_number: "",
  status: "",
  created__lte: "",
  destination_name: "",
  created__gte: "",
  external_reference__icontains: "",
  source_entity: "",
  supplier: "",
  network_search: "",
  supplier_reservation_reference: "",
  reference: "",
  market_type: "",
  destination_name__icontains: "",
};
const navbarSchema = yup.object().shape({
  destination_name: yup
    .string()
    .min(2, "Destination must be more than 2 characters")
    .max(100, "Destination must be less than 100 characters"),
  created__gte: yup.date(),
  created__lte: yup.date().max(new Date(), "Date cannot be in the future"),
});

const transferStyles = createUseStyles({
  Transfer: {
    ...genericIndexesStyles.indexes.mobile(),
    gridTemplateRows: "auto auto auto  1fr",
  },
  tableContainer: genericIndexesStyles.tableContainer.mobile(),
  table: tableStyles.table,
  headRow: tableStyles.head.row,
  headCell: tableStyles.head.cell,
  bodyRow: tableStyles.body.row,
  tablecell: tableStyles.body.cell,
  actionCell: {
    ...tableStyles.body.cell,
    // display: "grid",
    gap: variables.half_gap,
  },
  cxltablecell: { ...tableStyles.body.cell, minWidth: "9rem" },
  optionBookingContainer: {
    display: "inline-block",
    width: "fit-content",
    padding: "4px 10px 4px 10px",
    borderRadius: "5px",
    color: "white",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  optionBookingOrange: {
    backgroundColor: "orange",
  },
  optionBookingRed: { backgroundColor: "red" },
  optionBookingGreen: { backgroundColor: "green" },
  optionBookingBlue: { backgroundColor: "blue" },

  originNameCell: { ...tableStyles.body.cell, width: "9rem", minWidth: "9rem" },
  datesCell: { ...tableStyles.body.cell, width: "9rem", minWidth: "9rem" },
  statusCell: { ...tableStyles.body.cell, width: "7rem" },
  paxCell: { ...tableStyles.body.cell, width: "7rem", minWidth: "7rem" },
  [`@media ${variables.media.smallscreen}`]: {
    tableCell: {
      padding: `calc(${variables.normal_gap} * 2.5) 0`,
    },
  },
});
const Transfers = () => {
  const classes = transferStyles();

  useListPageSidebar();

  const [filters, setFilters] = useState(initialFilters);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [reference, setReference] = useState(null);
  const [marketType, setMarketType] = useState(null);

  const tableHeaders = commonTableHeaders({
    "Supplier Reservation Reference": (val) =>
      val.supplier_reservation_reference,
    "Origin Name": (val) => val.origin_name,
    Supplier: (val) => _.startCase(_.get(val, "supplier")),
    Tags: (val) => _.get(val, "tags", []).join(","),
    Destination: (val) => val.destination_name,
    Pax: (val) => {
      const pax = _.get(val, "pax", {});
      const children = _.get(pax, "children", 0);
      const adults = _.get(pax, "adults", 0);
      return `Children: ${children}, Adults: ${adults}`;
    },
    "Inbound Vehicle": (val) => val.inbound_vehicle,
    "Outbound Vehicle": (val) => val.outbound_vehicle,
    "Inbound Start": (val) => val.inbound_start,
    "Outbound Start": (val) => val.outbound_start,
    Cxl: (val) => <CRSCxlCell val={val} />,
    "Cancel Until": (val) => val.max_cancellation_date,
    "Market Type": (val) => val.market_type,
  });
  const handleApplyLocalFilters = (filters) => {
    handleApplyFilters(filters, setFilters, navbarSchema);
  };
  const results = useQueries({
    queries: [
      {
        queryKey: ["transfers", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          // if (filters.created__lte) {
          //   correctPayload["created__lte"] = DateTime.fromISO(
          //     filters.created__lte
          //   ).toISO();
          // }
          // if (filters.created__gte) {
          //   correctPayload["created__gte"] = DateTime.fromISO(
          //     filters.created__gte
          //   ).toISO();
          // }
          return await fetchTransferReservations({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
        onError: (error) => genericRequestErrorHandler(error),
      },
      {
        queryKey: ["transfersStats", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          if (filters.created__lte) {
            correctPayload["created__lte"] = filters.created__lte;
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = filters.created__gte;
          }
          return await getTransferReservationStats({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
      },
    ],
  });
  return (
    <div id="TRFListPage" className={classes.Transfer}>
      <Navbar
        filters={filters}
        initialFilters={initialFilters}
        onApplyFilters={handleApplyLocalFilters}
      />
      <HamburgerMenu />
      {!_.get(results, "1.isLoading", true) &&
        _.get(results, "1.data", null) && (
          <ReservationStats
            title="Reservation Stats"
            stats={_.get(results, "1.data.data.stats_per_currency")}
          />
        )}
      <ControlStrip
        limit={_.get(filters, "limit")}
        page={filters.page}
        count={_.get(results, "0.data.data.count")}
        onChangeLimit={(limit) => setFilters({ ...filters, limit, page: 1 })}
        onChangePage={(page) => setFilters({ ...filters, page })}
        orderOptions={[["created", "Created"]]}
        onChangeOrderOptions={(ordering) =>
          setFilters({ ...filters, ordering })
        }
      />
      {_.get(results, "0.isLoading", false) ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div className={classes.tableContainer}>
          <table className={classes.table}>
            <thead className={classes.thead}>
              <tr className={classes.headRow}>
                <th className={classes.headCell}>#</th>
                {Object.keys(tableHeaders).map((value, idx) => (
                  <th className={classes.headCell} key={idx}>
                    {value}
                  </th>
                ))}
                <th className={classes.headCell}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.get(results, "0.data.data.results", []).map((val, idx) => (
                <tr className={classes.bodyRow} key={idx}>
                  <td className={classes.tablecell}>{idx + 1}</td>
                  {Object.entries(tableHeaders).map((entry, ridx) => {
                    var cell = null;
                    const fn = entry[1];
                    switch (entry[0].toLowerCase()) {
                      case "pax":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.paxCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "origin name":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.originNameCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "cancel until":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.datesCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "inbound start":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.datesCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "created":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.datesCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "Cancel_Until":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.datesCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "status / booking mode":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.statusCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      default:
                        cell = fn(val) || "N/A";
                        break;
                    }
                    return (
                      <td className={classes.tablecell} key={ridx}>
                        {cell}
                      </td>
                    );
                  })}
                  <td className={classes.actionCell}>
                    <CustomButton
                      id={`detailTRFButton_${idx}`}
                      appearance="ghost"
                      onClick={() => {
                        setShowDetailModal(true);
                        setReference(val.reference);
                        setMarketType(val.market_type);
                      }}>
                      <strong>Details</strong>
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showDetailModal && (
        <DetailTranferModal
          onClose={() => setShowDetailModal(false)}
          reference={reference}
          market_type={marketType}
        />
      )}
    </div>
  );
};

export default Transfers;
